// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div[role=tooltip] > div > div {
  max-width: 500px;
  white-space: wrap !important;
}

.zappyride_incentive_web--StatusToolTip-module--statusTooltipContent--t5dzF1GzQerOHNXYcmKp {
  font-size: 14px;
  width: 400px;
  text-align: left;
  line-height: 20px;
  text-wrap: wrap;
}

.zappyride_incentive_web--StatusToolTip-module--ul--iFi1Z3556R7rwk99oOB4 {
  display: list-item;
  list-style-type: disc;
  margin-left: 20px;
}

.zappyride_incentive_web--StatusToolTip-module--li--XNFGqFRaB9BbKeTGyU5I {
  display: list-item;
}

.zappyride_incentive_web--StatusToolTip-module--span--gWRL2Pd0Hnkr15Wyqf5I {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/Tooltips/StatusToolTip/StatusToolTip.module.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,4BAAA;AACJ;;AAEA;EACI,eAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AACJ;;AAEA;EACI,kBAAA;EACA,qBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,iBAAA;AACJ","sourcesContent":["div[role='tooltip'] > div > div {\n    max-width: 500px;\n    white-space: wrap !important;\n}\n\n.statusTooltipContent {\n    font-size: 14px;\n    width: 400px;\n    text-align: left;\n    line-height: 20px;\n    text-wrap: wrap;\n}\n\n.ul {\n    display: list-item;\n    list-style-type: disc;\n    margin-left: 20px;\n}\n\n.li {\n    display: list-item;\n}\n\n.span {\n    font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statusTooltipContent": `zappyride_incentive_web--StatusToolTip-module--statusTooltipContent--t5dzF1GzQerOHNXYcmKp`,
	"ul": `zappyride_incentive_web--StatusToolTip-module--ul--iFi1Z3556R7rwk99oOB4`,
	"li": `zappyride_incentive_web--StatusToolTip-module--li--XNFGqFRaB9BbKeTGyU5I`,
	"span": `zappyride_incentive_web--StatusToolTip-module--span--gWRL2Pd0Hnkr15Wyqf5I`
};
export default ___CSS_LOADER_EXPORT___;
